import Vue from 'vue';
import Router from 'vue-router';
import LoginPage from '../components/auth/LoginPage.vue';
import Catches from '../components/catches/CatchesView.vue';
import UpdateCatchPage from '../components/catches/UpdateCatchPage.vue';
import UpdateCatcherPage from '../components/catchers/UpdateCatcherPage.vue';
import UpdateRegionPage from '../components/regions/UpdateRegionPage.vue';
import CatchPage from '../components/catches/CatchPage.vue';
import CatcherPage from '../components/catchers/CatcherPage.vue';
import RegionPage from '../components/regions/RegionPage.vue';
import ProfilePage from '../components/profile/ProfilePage.vue';

Vue.use(Router);

// Every new root path requires a new setting in Azure Functions Proxy

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Catches',
            component: Catches,
        },
        {
            path: '/auth',
            name: 'Auth',
            component: LoginPage,
        },
        {
            path: '/profiles/me',
            name: 'ProfilePage',
            component: ProfilePage,
        },
        {
            path: '/regions/:id',
            name: 'RegionPage',
            component: RegionPage,
            props: true,
        },
        {
            path: '/regions/:id/edit',
            name: 'EditRegion',
            component: UpdateRegionPage,
            props: true,
        },
        {
            path: '/catches/add',
            name: 'AddCatch',
            component: UpdateCatchPage,
            props: true,
        },
        {
            path: '/catches/:id/edit',
            name: 'EditCatch',
            component: UpdateCatchPage,
            props: true,
        },
        {
            path: '/catches/:id',
            name: 'CatchPage',
            component: CatchPage,
            props: true,
        },
        {
            path: '/catchers/add',
            name: 'AddCatcher',
            component: UpdateCatcherPage,
            props: true,
        },
        {
            path: '/catchers/:id/edit',
            name: 'EditCatcher',
            component: UpdateCatcherPage,
            props: true,
        },
        {
            path: '/catchers/:id',
            name: 'Catchers',
            component: CatcherPage,
        },
    ],
});
